<template>
<base-modal v-model="isVisible" :title="$t('availabilityRequest.title')" @shown="showForm" @hidden="resetForm">
  <div class="text-center">
    <base-select class="mb-4" clearable :loading="form.service.loading" :options="form.service.options" valueProp="id" label="name" v-model="form.service.value" :placeholder="form.service.placeholder"></base-select>
    <base-select v-if="!hideFirstAppointmentSelector" class="mb-4" clearable :loading="form.firstAppointment.loading" :options="form.firstAppointment.options" valueProp="id" label="name" v-model="form.firstAppointment.value" :placeholder="form.firstAppointment.placeholder"></base-select>
    <base-textarea v-model="form.availabilityDescription.value" :placeholder="form.availabilityDescription.placeholder"></base-textarea>
    <base-select class="mb-4" clearable :loading="form.haveInsurance.loading" @input="haveInsuranceSelected" :options="form.haveInsurance.options" valueProp="id" label="name" v-model="form.haveInsurance.value" :placeholder="form.haveInsurance.placeholder"></base-select>
    <base-select class="mb-4" clearable v-if="form.insurance.show" :loading="form.insurance.loading" :options="form.insurance.options" valueProp="name" label="name" v-model="form.insurance.value" :placeholder="form.insurance.placeholder"></base-select>
    <b-row>
        <b-col class="mb-4" cols="12" md="5"><base-select clearable v-model="form.phonePrefix.value" searchable :placeholder="$t('signupOH.registerPhonePrefix')" :options="form.phonePrefix.options" :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="idCountry"></base-select></b-col>
        <b-col cols="12" md="7"><base-input v-model="form.phone.value" :placeholder="form.phone.placeholder"></base-input></b-col>
    </b-row>
    <base-textarea v-model="form.description.value" :placeholder="form.description.placeholder"></base-textarea>
    <base-checkbox v-model="termsAccepted">
      <span v-html="$t('signupOH.accept-terms-patient')"></span>
    </base-checkbox>
    <VueRecaptcha class="custom-recaptcha" :sitekey="siteKey" :load-recaptcha-script="true" @verify="validCaptcha = true" @error="validCaptcha = false" @expired="validCaptcha = false"></VueRecaptcha>
    <base-button class="mt-4" @click="sendForm">{{$t('send')}}</base-button>
  </div>
</base-modal>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { recaptcha } from '@/constants/recaptcha'
import BaseModal from '@/components/base/BaseModal.vue'
import geographyRepository from '@/repositories/GeographyRepository'
import appointmentsRepository from '@/repositories/AppointmentsRepository'
import professionalAvailabilityRequestRepository from '@/repositories/ProfessionalAvailabilityRequestRepository'
import healthServicesRepository from '@/repositories/HealthServicesRepository'
import insurersRepository from '@/repositories/InsurersRepository'
import { getCurrencyByDomain } from '@/constants/currencies'
import { MX_COUNTRY_ID, SPAIN_COUNTRY_ID } from '@/constants/db/countries'
import { inMx, inEs } from '@/helpers/global.helpers'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'forms/availability-request'

export default {
  components: {
    BaseModal,
    VueRecaptcha
  },
  props: {
		serviceId: String,
    userId: String,
    value: Boolean
  },
  mixins: [i18nMixin(I18N_FILE)],
  data () {
    return {
      form: {
        service: {
            loading: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.service'),
            value: null
        },
        availabilityDescription: {
            placeholder: this.$t('availabilityRequest.form.availabilityDescription'),
            value: null
        },
        phonePrefix: {
            loading: false,
            options: [],
            value: null
        },
        phone: {
            loading: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.phone'),
            value: null
        },
        haveInsurance: {
            loading: false,
            show: false,
            options: [{id: false, name: this.$t('single')}, {id: true, name: this.$t('insurance')}],
            defaultOptions: [{id: false, name: this.$t('single')}, {id: true, name: this.$t('insurance')}],
            placeholder: this.$t('availabilityRequest.form.haveInsurance'),
            value: null
        },
        insurance: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.insurance'),
            value: null
        },
        description: {
            placeholder: this.$t('availabilityRequest.form.description'),
            value: null
        },
        firstAppointment: {
            loading: false,
            options: [{id: true, name: this.$t('yes')}, {id: false, name: this.$t('no')}],
            defaultOptions: [{id: true, name: this.$t('yes')}, {id: false, name: this.$t('no')}],
            placeholder: this.$t('availabilityRequest.form.firstAppointment'),
            value: null
        }
      },
      termsAccepted: false,
      validCaptcha: false,
      hideFirstAppointmentSelector: false,
      siteKey: recaptcha
    }
  },
  created () {
  },
  methods: {
    showForm () {
      this.checkIfFirstAppointment()
      this.getServices()
      this.loadPhonePrefixes()
    },
    loadPhonePrefixes () {
      geographyRepository.getCountries().then(response => {
        this.form.phonePrefix.options = response.data
        this.form.phonePrefix.value = inMx ? MX_COUNTRY_ID : inEs ? SPAIN_COUNTRY_ID : null
      })
    },
    getServices () {
      healthServicesRepository.getHealthServicesByUserId(this.userId).then((response) => {
            this.form.service.options = response.data.map(item => {
              return {id: item.id, name: `${this.$i18nHelpers.normalize(item.name)} - ${item.price !== null ? `${item.price}${getCurrencyByDomain()}` : ''}`}
            })
						if (this.serviceId) {
							this.form.service.value = this.serviceId
						}
        })
    },
    haveInsuranceSelected () {
      if (this.form.haveInsurance.value && this.form.insurance.options.length === 0) this.getInsurers()
      this.form.insurance.show = this.form.haveInsurance.value
    },
    getInsurers () {
      insurersRepository.getInsurers().then(response => {
        this.form.insurance.options = response.data
      })
    },
    checkIfFirstAppointment () {
      appointmentsRepository.isFirstAppointment(this.profId).then(response => {
        if (response.data) {
          this.hideFirstAppointmentSelector = true
          this.form.firstAppointment.value = true
        }
      })
    },
    sendForm () {
      if (!this.form.service.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.service'))
      } else if (this.form.firstAppointment.value === null) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.firstAppointment'))
      } else if (this.form.haveInsurance.value === null) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.selectInsurance'))
      } else if (this.form.haveInsurance.value && this.form.insurance.value === null) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.insurance'))
      } else if (!this.form.phonePrefix.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.phonePrefix'))
      } else if (!this.form.phone.value || this.$validators.validate(this.form.phone.value, ['phone']) === false) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.phone'))
      } else if (!this.form.description.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.description'))
      } else if (!this.termsAccepted) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.terms'))
      } else if (!this.validCaptcha) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.captcha'))
      } else {
        let data = {
          userId: this.userId,
          phonePrefix: this.form.phonePrefix.value,
          phone: this.form.phone.value,
          request: this.form.description.value,
          appointmentDate: this.form.availabilityDescription.value,
          insurance: this.form.insurance.value,
          isFirstAppointment: this.form.firstAppointment.value,
          service: this.form.service.value
        }
        professionalAvailabilityRequestRepository.sendServiceAvailabilityRequest(data).then(response => {
          if (response.data) {
            this.$store.dispatch('showSuccessAlert', this.$t('availabilityRequest.success'))
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
          }
          this.resetForm()
          this.isVisible = false
        })
      }
    },
    resetForm () {
      Object.keys(this.form).forEach(key => {
        this.form[key].value = this.form[key].defaultValue ? this.form[key].defaultValue : null
        this.form[key].options = this.form[key].defaultOptions ? this.form[key].defaultOptions : []
        this.form[key].show = false
      })
      this.termsAccepted = false
      this.validCaptcha = false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
}
}
</script>

<style lang="scss" scoped>
/deep/ .custom-recaptcha > div {
  width: auto !important;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ServicesRequestModal.vue